/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SchoolContext from "../../../Context/SchoolContext";
import ajaxBank from "../../../util/remote/ajaxBank";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import AppContainer from "../../../Components/Structure/AppContainer";
import TableHeader from "../../../Components/Common/TableHeader";
import CreditBalancesSearchForm from "../../../Components/Common/Statistics/CreditBalancesSearchForm";
import Loader from "../../../Components/Common/Loader";
import Pagination from "../../../Components/Common/Pagination";
import * as XLSX from "xlsx";
import PrintFilterStudentBalanceForm from "../../../Components/Statistics/CreditBalances/PrintFilterStudentBalanceForm";
import useStateCallback from "../../../util/customHooks/useStateCallback";


function BuzztimeCreditBalancesPage() {
    const {schoolList} = useContext(SchoolContext);
    const [query, setQuery] = useState("");
    const [school, setSchool] = useState("");
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [modal, setModal] = useStateCallback(false);

    const [overallCreditBalance, setOverallCreditBalance] = useState(false);
    const [schoolCreditBalances, setSchoolCreditBalances] = useState([]);
    const [first, setFirst] = useState("");
    const [printableList, setPrintableList] = useState([]);

    const [meta, setMeta] = useState([]);
    const [creditBalances, setCreditBalances] = useState([]);

  useEffect(() => {
      if (query || school ) {
          searchCreditBalances();
      } else {
          getCreditBalances(page);
      }
  }, [page]);

  useEffect(() => {
        getOverallCreditBalance();
        getSchoolCreditBalances();

}, []);

  const getOverallCreditBalance = async () => {
      const server_response = await ajaxBank.fetchStudentCreditBalance();
      if (server_response.status === "OK") {
        setOverallCreditBalance(server_response.details);
      } else {
        setOverallCreditBalance("404");
      }
    };
  
  const getCreditBalances = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxStudent.listAllCreditBalances(currentPage);
    setLoading(false);

    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
        setMeta(server_response.details.meta.totalPages);
        setCreditBalances(server_response.details.data || []);
    } else {
        setCreditBalances([]);
    }
};

const searchCreditBalances = async (e) => {
    if (e) {
        e.preventDefault();
    }
    setLoading2(true);
    const server_response = await ajaxStudent.searchAllCreditBalances(page, school, query);
    setLoading2(false);
    if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setCreditBalances(server_response.details.data || []);
    } else {
        setCreditBalances([]);
    }
};

const getSchoolCreditBalances = async () => {
    setLoading3(true);
    const server_response = await ajaxBank.fetchAllSchoolCreditBalances();
    setLoading3(false);
    if (server_response.status === "OK") {
        setSchoolCreditBalances(server_response.details || []);  
    } else {
        setSchoolCreditBalances([]);
    }
};

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const setBalances = (e) => {
    e.preventDefault();
    setQuery("");
    setSchool("");
    setPage(1);
    getCreditBalances(1);
    
  };

  const handleModal = () => {
    setModal(false, () =>
      setModal(
        <PrintFilterStudentBalanceForm
          g={setPrintableList}
          h={exportToExcel}
          printableList={printableList}
          isOpen={true}
        />
      )
    );
  };

  const exportToExcel = (data) => {
          const worksheetData = (data || []).map((item) => ({
            "Student Name": item.user,
            "Buzz Number": item.username,
            "School Name": item.school,
            "Class": item.group,
            "Buzztime Credit": item.balance.total_c,
           }));
        
          const worksheet = XLSX.utils.json_to_sheet(worksheetData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Credit Balances");
        
          XLSX.writeFile(workbook, "credit_balances_list.xlsx");
    };


  return (
    <AppContainer title="Student Credit Balances">
        {modal}
      <Toaster position="top-center" reverseOrder={false} />
      <div className="row">
            <div class="col-lg-12">
                <div class="card custom-card" style={{ paddingBottom: "10px" }}>
                    <div className="card-body map-card gradient-my-blue">
                        <div class="item-title mb-2" style={{ color: "white" }}>
                            <b>OVERALL</b>
                        </div>
                        <div class="row">
                        
                            <div class="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                <div class="text-center">
                                    <h2 class="mb-1 number-font" style={{ color: "white" }}>
                                        <span class="counter">
                                            {overallCreditBalance? overallCreditBalance:"..."}
                                        </span>
                                    </h2>
                                    <p class="mb-0 text-light"> Student Credit Balance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>

        <div className="row">
            <div className="col-lg-9 col-md-12 col-12 col-sm-12">
                <div className="row">
                <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "Student Credit Balances List"
          subtitle="List of all the students with their credit balances sorted from highest to lowest"    
        />
        <div class="dropdown">
            
          
          
          <Link class="dropdown-toggle"  role="button" data-toggle="dropdown" aria-expanded="false"><i class="fas fa-ellipsis ml-3"></i></Link>
            <div class="dropdown-menu dropdown-menu-right">
                <Link class="dropdown-item" onClick={setBalances}><i class="fas fa-redo-alt"></i>Refresh</Link>
                <Link class="dropdown-item" onClick={handleModal}><i class="fas fa-file-excel"></i>Export as Excel File</Link>
                <Link class="dropdown-item" to={"/students/activation-bonus"} ><i class="fas fa-circle-user"></i>Activation Bonus Students</Link>         
            </div>


        </div>
      </div>

      <CreditBalancesSearchForm school={school} student={query} setSchool={setSchool} setStudent={setQuery}
      searchCreditBalances={searchCreditBalances} setPage={setPage} resetSearch={setBalances} schoolList={schoolList}/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">No.</th>
                <th scope="col">Student Name</th>
                <th scope="col">Buzz Number</th>

                <th scope="col"> School</th>
                <th scope="col"> Buzztime Credit</th>
                
                </tr>
            </thead>
            <tbody>
                {creditBalances.length > 0 ? (
                    creditBalances.map((item, index) => (
                    <tr key={index}>
                        

                        <td>{index + first + 1} </td>
                        
                        <td><OverlayTrigger placement="top" overlay={
                                                                <Tooltip id="refresh-tooltip">
                                                                    View Statement
                                                                </Tooltip>}><Link to={`/credit-balances/statement/${item.user_id}?username=${encodeURIComponent(item.username)}&user=${encodeURIComponent(item.user)}&balance=${encodeURIComponent(item.balance.total_c)}`}>{item.user}
                                                                </Link></OverlayTrigger></td>
                        <td>{item.username}</td>

                        <td>{item.school}</td>
                        <td>{item.balance.total_c}</td>

                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                            No students registered yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
                
                
                </div>
            </div>
            <div class="col-lg-3 col-md-12 col-12 col-sm-12">
                <div className="row">
                {loading3 ? (
                    <Loader />
                      ):(
                        schoolCreditBalances.map((item, index) => (
                            <div key={index} class="col-lg-12 col-md-12 col-12 col-sm-12">
								<div class="card custom-card">
									<div class="card-body">
										<div>
											<h6>{item.school_name}</h6>
											<h6><span class="fs-30 me-2" style={{fontSize:"20px"}}>{item.balance?item.balance.total_c:"..."}</span></h6>
										</div>
									</div>
								</div>
                                
							</div>)))}
                           
                    
                    
                </div>
	        </div>
        </div>
        

        
      
    </AppContainer>
  );
}

export default BuzztimeCreditBalancesPage;
